import React from 'react'

import { useAuthContext } from 'providers/AuthProvider'
import SuccessPage from './SuccessPage'

const SubscriptorSuccess = () => {
  const { signinRedirect } = useAuthContext()
  
  const title = '¡Verificaste tu email, tu cuenta está lista!'
  const subtitle = 'Ahora solo debes iniciar sesión en la web de interbanking, puedes hacerlo clickeando en el botón de abajo'
  const pretitle = null
  const action = signinRedirect

  return (
    <SuccessPage
      title={title}
      subtitle={subtitle}
      pretitle={pretitle}
      action={action}
    />
  )
}

export default SubscriptorSuccess
